import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Onboarding.css";
import vylabsLogo from "../../Assets/Images/Vylabs-Logo.png";
import dashboardBg1 from "../../Assets/Images/maximize-reach.svg";
import dashboardBg2 from "../../Assets/Images/match-precision.svg";
import analyzeCard from "../../Assets/Images/screen-smarter.svg";

const Onboarding = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const slides = [
    {
      image: dashboardBg1,
      title: "Maximize Your Reach",
      description: "Discover quality candidates with wider, smarter search filters that do the heavy lifting for you."
    },
    {
      image: dashboardBg2,
      title: "Match with Precision",
      description: "Our job-matching algorithm connects you with the best-fit talent—based on skills, experience, and culture."
    },
    {
      image: analyzeCard,
      title: "Screen Smarter, Not Harder",
      description: "Instantly spot top talent with AI-powered profiles that highlight what really matters."
    }
  ];

  useEffect(() => {
    // Check if screen width is greater than 480px, if so redirect to login
    const checkScreenSize = () => {
      if (window.innerWidth > 480) {
        navigate("/login");
      }
    };

    // Check on initial load
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => window.removeEventListener("resize", checkScreenSize);
  }, [navigate]);

  // Auto-rotate slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Handle touch events for swiping
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swipe left, go to next slide
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }

    if (touchStart - touchEnd < -50) {
      // Swipe right, go to previous slide
      setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    }
  };

  const handleGetStarted = () => {
    navigate("/login");
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-header">
        <img src={vylabsLogo} alt="ClickUp Logo" className="onboarding-logo" />
      </div>

      <div 
        className="carousel-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div 
          className="carousel-slides" 
          style={{ transform: `translateX(-${currentSlide * 110}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="carousel-slide">
              <div className="slide-image-container">
                <img src={slide.image} alt={`Slide ${index + 1}`} className="slide-image" />
              </div>
              <h1 className="slide-title">{slide.title}</h1>
              <p className="slide-description">{slide.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <div 
            key={index} 
            className={`indicator ${currentSlide === index ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      <div className="onboarding-footer">
        <button className="get-started-button" onClick={handleGetStarted}>
          Get started
        </button>
      </div>
    </div>
  );
};

export default Onboarding;